import React from 'react';
import { Helmet } from "react-helmet";

const FAQs = () => (
  <>
    <Helmet>
      <title>FAQs | Platform Engineering | Fepsec</title>
    </Helmet>
    <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
            Frequently Asked Questions (FAQs)
          </h1>
          <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
            <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-4">What services do you offer?</h2>
            <p className="text-gray-700 mb-6">We offer consultancy, platform engineering, managed OpenShift, Kubernetes services, training, and support for cloud-native technologies.</p>
            <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">How can I get started?</h2>
            <p className="text-gray-700 mb-6">Contact us via our online form or email to discuss your requirements and schedule a discovery call.</p>
            <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">Do you provide training?</h2>
            <p className="text-gray-700 mb-6">Yes, we offer Red Hat and cloud certification training, hands-on labs, and enablement programs for teams and individuals.</p>
            <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">Where are you located?</h2>
            <p className="text-gray-700">Our main office is in Lagos, Nigeria, but we serve clients globally.</p>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default FAQs;
